import React, { useMemo, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLayout } from "../../contexts/layoutContext";
import { NAV_ITEMS, LOGO_URL, isRouteActive } from "../../config/navigation";
import "./headers.css";

export const Headers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDesktop, sidebarCollapsed, sidebarExpanded } = useLayout();

  const handleNavigate = useCallback(
    (route) => () => navigate(route),
    [navigate]
  );

  const isActive = useCallback(
    (route) => isRouteActive(location.pathname, route),
    [location.pathname]
  );

  const showLabels = sidebarExpanded;

  const sidebarClassName = useMemo(
    () =>
      `app-sidebar fixed top-0 left-0 z-40 flex h-screen flex-col bg-blue-100 shadow-lg transition-[width] duration-200 ease-out ${
        sidebarCollapsed ? "w-16" : "w-56"
      }`,
    [sidebarCollapsed]
  );

  if (!isDesktop) return null;

  return (
    <aside className={sidebarClassName} aria-label="Menú principal">
      <div className="flex shrink-0 items-center justify-center border-b border-blue-200 px-3 py-4">
        <img
          className={`rounded-xl object-contain transition-all duration-200 ${
            showLabels ? "h-16 w-16" : "h-10 w-10"
          }`}
          src={LOGO_URL}
          alt="Muv Service"
        />
      </div>

      {showLabels && (
        <p className="px-4 pb-2 text-center text-xs font-semibold uppercase tracking-wide text-blue-800 opacity-70">
          Panel admin
        </p>
      )}

      <nav className="app-sidebar-nav flex-1 overflow-y-auto overflow-x-hidden px-2 py-2">
        <ul className="flex w-full flex-col gap-1">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.route);

            return (
              <li key={item.route}>
                <button
                  type="button"
                  onClick={handleNavigate(item.route)}
                  title={!showLabels ? item.label : undefined}
                  className={`app-sidebar-item w-full ${
                    active ? "app-sidebar-item--active" : ""
                  } ${showLabels ? "justify-start gap-3 px-3" : "justify-center px-0"}`}
                >
                  <Icon size={22} className="shrink-0" aria-hidden />
                  {showLabels && (
                    <span className="truncate text-left text-sm font-medium leading-tight">
                      {item.label}
                    </span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};
